import { render } from "./RHModule.vue?vue&type=template&id=2176e11b&scoped=true"
import script from "./RHModule.vue?vue&type=script&lang=js"
export * from "./RHModule.vue?vue&type=script&lang=js"

import "./RHModule.vue?vue&type=style&index=0&id=2176e11b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2176e11b"]])

export default __exports__